var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1400px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "demo-drawer_title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v("订单详情")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "demo-drawer__content",
            },
            [
              _vm.orderDatalist
                ? _c(
                    "div",
                    { staticClass: "description" },
                    [
                      _c("el-divider"),
                      _vm._v(" "),
                      _vm.channelVisBle
                        ? _c(
                            "div",
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("渠道订单信息"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.orderDatalist
                                      .supplierOrderDetailList,
                                    size: "mini",
                                    "highlight-current-row": true,
                                    "header-cell-style": { fontWeight: "bold" },
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "el-row",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "5px",
                                                  },
                                                  attrs: {
                                                    type: "flex",
                                                    align: "middle",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 7 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 渠道订单号： "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        _vm._s(
                                                          row.supplierOrderNo
                                                        ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 4 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 供应商商户： "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(row.channel) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 4 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 渠道订单状态： "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "supplierOrderStatusFilter"
                                                            )(row.orderStatus)
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "right",
                                                        "padding-right": "10px",
                                                      },
                                                      attrs: { span: 10 },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [_vm._v(" 下单时间：")]
                                                      ),
                                                      _vm._v(
                                                        _vm._s(row.createTime) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-table",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                  },
                                                  attrs: {
                                                    data: row.supplierOrderDetailList,
                                                    border: "",
                                                    "show-header": true,
                                                  },
                                                },
                                                [
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商品图",
                                                      "min-width": "80",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "demo-image__preview",
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-image",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "36px",
                                                                          height:
                                                                            "36px",
                                                                        },
                                                                      attrs: {
                                                                        src: scope
                                                                          .row
                                                                          .image,
                                                                        "preview-src-list":
                                                                          [
                                                                            scope
                                                                              .row
                                                                              .image,
                                                                          ],
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商品名称",
                                                      prop: "productName",
                                                      "min-width": "120",
                                                      align: "center",
                                                      "show-overflow-tooltip": true,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "SKU名称",
                                                      prop: "skuName",
                                                      "min-width": "120",
                                                      align: "center",
                                                      "show-overflow-tooltip": true,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商品售价",
                                                      prop: "price",
                                                      "min-width": "100",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "￥" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .price
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商户支付价",
                                                      prop: "payPrice",
                                                      "min-width": "100",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "￥" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .payPrice
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商户成本价",
                                                      prop: "vipPrice",
                                                      "min-width": "100",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "￥" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .vipPrice
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      prop: "payNum",
                                                      label: "购买数量",
                                                      "min-width": "80",
                                                      align: "center",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "订单状态",
                                                      prop: "orderStatus",
                                                      "min-width": "80",
                                                      "show-overflow-tooltip": true,
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "supplierOrderStatusFilter"
                                                                      )(
                                                                        scope
                                                                          .row
                                                                          .orderStatus
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "物流状态",
                                                      prop: "orderStatus",
                                                      "min-width": "100",
                                                      "show-overflow-tooltip": true,
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "supplierOrderLogisticsStatusFilter"
                                                                      )(
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "操作",
                                                      "min-width": "250",
                                                      fixed: "right",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "2" ||
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "5" ||
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "6",
                                                                      expression:
                                                                        "\n                          scope.row.logisticsStatus === '2' ||\n                          scope.row.logisticsStatus === '5' ||\n                          scope.row.logisticsStatus === '6'\n                        ",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "text",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.confirmGoods(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "确认收货"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "2" ||
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "5" ||
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "6" ||
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "3",
                                                                      expression:
                                                                        "\n                          scope.row.logisticsStatus === '2' ||\n                          scope.row.logisticsStatus === '5' ||\n                          scope.row.logisticsStatus === '6' ||\n                          scope.row.logisticsStatus === '3'\n                        ",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "text",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openLogistics(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "查询物流"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        !scope
                                                                          .row
                                                                          .disputeId &&
                                                                        !_vm
                                                                          .orderDatalist
                                                                          .isVirtual,
                                                                      expression:
                                                                        "!scope.row.disputeId && !orderDatalist.isVirtual",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "text",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRefund(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "申请退款"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .disputeId,
                                                                      expression:
                                                                        "scope.row.disputeId",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "text",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRefundDetail(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "退款详情"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1849984729
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("商品信息"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    size: "mini",
                                    data: _vm.orderDatalist.orderDetailList,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "商品图", width: "80" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "demo-image__preview",
                                                },
                                                [
                                                  _c("el-image", {
                                                    attrs: {
                                                      src: scope.row.image,
                                                      "preview-src-list": [
                                                        scope.row.image,
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1825039654
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "productName",
                                      "min-width": "200",
                                      "show-overflow-tooltip": true,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "price",
                                      label: "商品售价",
                                      "min-width": "90",
                                      align: "center",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "sku",
                                      label: "商品规格",
                                      "min-width": "90",
                                      align: "center",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      parseFloat(_vm.orderDatalist.shippingType) === 3
                        ? [
                            _c("el-divider"),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("充值信息"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "acea-row" }, [
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "\n              充值类型：" +
                                    _vm._s(
                                      _vm.orderDatalist.userRechargeInfo
                                        ? _vm.orderDatalist.userRechargeInfo
                                            .accountType == "1"
                                          ? "手机号码"
                                          : "其他"
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "\n              充值账号：" +
                                    _vm._s(
                                      _vm.orderDatalist.userRechargeInfo
                                        ? _vm.orderDatalist.userRechargeInfo
                                            .rechargeAccount
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      parseFloat(_vm.orderDatalist.shippingType) === 1
                        ? [
                            _c("el-divider"),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("收货信息"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "acea-row" }, [
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "收货人：" +
                                    _vm._s(_vm.orderDatalist.realName)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "收货电话：" +
                                    _vm._s(_vm.orderDatalist.userPhone)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "收货地址：" +
                                    _vm._s(_vm.orderDatalist.userAddress)
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "title" }, [_vm._v("订单信息")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "acea-row" }, [
                        _c(
                          "div",
                          { staticClass: "description-term" },
                          [
                            _c(
                              "font",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.orderDatalist.type === 1,
                                    expression: "orderDatalist.type === 1",
                                  },
                                ],
                                attrs: { color: "#f6ae02" },
                              },
                              [_vm._v("[视频号]")]
                            ),
                            _vm._v(" "),
                            _c(
                              "font",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.orderDatalist.type === 2,
                                    expression: "orderDatalist.type === 2",
                                  },
                                ],
                                attrs: { color: "#1890ff" },
                              },
                              [_vm._v("[秒杀]")]
                            ),
                            _vm._v(
                              "\n            订单号：" +
                                _vm._s(_vm.orderDatalist.orderNo) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "description-term",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v("\n            订单状态：\n            "),
                            _vm.orderDatalist.refundStatus === 3
                              ? _c("span", [_vm._v("已退款")])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("orderStatusFilter")(
                                        _vm.orderDatalist.status
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "支付状态：" +
                              _vm._s(
                                _vm.orderDatalist.paid ? "已支付" : "未支付"
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商品总数：" + _vm._s(_vm.orderDatalist.totalNum)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商品总价：" +
                              _vm._s(_vm.orderDatalist.proTotalPrice)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "实际支付：" + _vm._s(_vm.orderDatalist.vipPrice)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "支付方式：" +
                              _vm._s(
                                _vm._f("payTypeFilter")(
                                  _vm.orderDatalist.payType
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "\n            配送方式：" +
                              _vm._s(
                                parseFloat(_vm.orderDatalist.shippingType) === 1
                                  ? "邮寄"
                                  : parseFloat(
                                      _vm.orderDatalist.shippingType
                                    ) === 2
                                  ? "门店自提"
                                  : "虚拟充值"
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "创建时间：" + _vm._s(_vm.orderDatalist.createTime)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "支付时间：" + _vm._s(_vm.orderDatalist.payTime)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "用户备注：" +
                              _vm._s(
                                _vm._f("filterEmpty")(
                                  _vm.orderDatalist.userRemark
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商家备注：" +
                              _vm._s(
                                _vm._f("filterEmpty")(
                                  _vm.orderDatalist.merchantRemark
                                )
                              )
                          ),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.orderDatalist
        ? _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.modal2, width: "600px" },
              on: {
                "update:visible": function ($event) {
                  _vm.modal2 = $event
                },
              },
            },
            [
              _c("div", { staticClass: "logistics acea-row row-top" }, [
                _c("div", { staticClass: "logistics_img" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/imgs/expressi.jpg") },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "logistics_cent" }, [
                  _c("span", { staticClass: "mb10" }, [
                    _vm._v("物流公司：" + _vm._s(_vm.resultInfo.expName)),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("物流单号：" + _vm._s(_vm.resultInfo.number)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.resultInfo.courierPhone,
                          expression: "resultInfo.courierPhone",
                        },
                      ],
                    },
                    [_vm._v("快递站：" + _vm._s(_vm.resultInfo.courierPhone))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.resultInfo.courierPhone,
                          expression: "resultInfo.courierPhone",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "快递员电话：" + _vm._s(_vm.resultInfo.courierPhone)
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "acea-row row-column-around trees-coadd" },
                [
                  _c(
                    "div",
                    { staticClass: "scollhide" },
                    [
                      _c(
                        "el-timeline",
                        { attrs: { reverse: _vm.reverse } },
                        _vm._l(_vm.result, function (item, i) {
                          return _c("el-timeline-item", { key: i }, [
                            _c("p", {
                              staticClass: "time",
                              domProps: { textContent: _vm._s(item.time) },
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "content",
                              domProps: { textContent: _vm._s(item.status) },
                            }),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.modal2 = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款",
            visible: _vm.dialogFormVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "退款类型", "label-width": "100px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择退款类型" },
                      model: {
                        value: _vm.form.bizClaimType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bizClaimType", $$v)
                        },
                        expression: "form.bizClaimType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "仅退款", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "退货退款", value: "3" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "货物状态", "label-width": "100px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择货物状态" },
                      model: {
                        value: _vm.form.goodsStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "goodsStatus", $$v)
                        },
                        expression: "form.goodsStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未收到货", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已收到货", value: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已寄回", value: "3" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "未发货", value: "4" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "卖家确认收货", value: "5" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已发货", value: "6" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.proofRequired
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lang",
                      attrs: { label: "上传商品图片：", prop: "sliderImages" },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: "",
                            "http-request": _vm.handleUploadForm,
                            headers: _vm.myHeaders,
                            "show-file-list": true,
                            multiple: "",
                          },
                        },
                        [
                          _c("div", { staticClass: "upLoadPicBox" }, [
                            _c("div", { staticClass: "upLoad" }, [
                              _c("i", { staticClass: "el-icon-upload2" }),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleOnsubmitRefund()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }